import { FC, SVGProps } from 'react';

export const Divider: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="2"
      viewBox="0 0 100 2"
      preserveAspectRatio="none"
      fill="none"
      style={{ marginBottom: '20px' }}
      {...props}
    >
      <path d="M0 1H100" stroke="#CCCFD0" strokeWidth="1" />
    </svg>
  );
};

export default Divider;
